import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/ExpandMore.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Accordion/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/List/List.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/ListItem/ListItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/png/bg-tecture.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/callUs.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/chatbot.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/dots.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/dotted-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/email.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/footer-texture.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/logo-15.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/lower-wave.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/message.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/settings.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/upper-wave.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/svg/user.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pageComponents)/featuredScholarshipSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pageComponents)/heroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pageComponents)/programSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/molecules/accordian.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/contactUsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/navbar/index.tsx");
